// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__2ONxQ","title":"Portfolio_title__ktZ7c","title-span":"Portfolio_title-span__8JYVK","cards":"Portfolio_cards__ttDR4"};